import SalePointsConfig from './tables-configs/salePoints.json';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {CommonService} from '../services/common.service';
import {Component, OnInit} from '@angular/core';
import {Details} from '../details/details';
import {EventLogsService} from '../services/event-logs.service';
import {InventoriesService} from '../services/inventories.service';
import {LoadingService} from '../services/loading.service';
import {MatDialog} from '@angular/material';
import {SimpleConfirmActionDialogComponent} from '../common/simple-confirm-action-dialog/simple-confirm-action-dialog.component';
import {ToastMessagesService} from '../services/toast-messages.service';

@Component({
  templateUrl: './inventory-details.component.html'
})
export class InventoryDetailsComponent extends Details implements OnInit {
  public basicDetailsConfig: any;
  public eventLogs: any[];
  public initializePage: boolean;
  private inventory: any;
  public salePointsConfig: any;
  public inventoryEventLogs: any[];

  constructor(private activatedRoute: ActivatedRoute,
              private authService: AuthService,
              private commonService: CommonService,
              private eventLogsService: EventLogsService,
              private inventoriesService: InventoriesService,
              private loadingService: LoadingService,
              private matDialog: MatDialog,
              private router: Router,
              private toastMessagesService: ToastMessagesService) {
    super();

    this.salePointsConfig = SalePointsConfig;
  }

  public ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((params) => {
      let promises: Array<Promise<any>>;

      promises = [];

      const promise1 = this.inventoriesService.getInventory(+params.get('id')).then((inventory) => {
        this.inventory = inventory;
      });

      promises.push(promise1);

      if (this.showEventLogs()) {
        const promise2 = this.eventLogsService.getRefrigeratorEventLogs('inventory', +params.get('id')).then((eventLogs) => {
          this.eventLogs = eventLogs;
        });

        promises.push(promise2);
      }

      const promise3 = this.inventoriesService.checkIFNotificationExists(+params.get('id')).then((result) => {
        this.inventoryEventLogs = result;
      });

      promises.push(promise3);


      Promise.all(promises).then(() => {
        this.salePointsConfig.filter = 'inventory_id = ' + this.inventory.id;

        this.basicDetailsConfig = {
          showActions: this.showActions(),
          actions: [],
          status_name: this.inventory.is_completed_name,
          status_value: this.inventory.is_completed_value,
          subtitle: [
            {
              title: 'Ημερομηνία Δημιουργίας',
              value: this.commonService.formatDate(this.inventory.date_created)
            },
            {
              navigateURL: `#/user/${this.inventory.user_id}`,
              title: 'Υπάλληλος',
              type: 'link',
              value: `${this.inventory.user_name}`
            }
          ],
          title: 'Πληροφορίες Απογραφής'
        };

        this.initializeActions().then(() => {
        });

        this.initializePage = true;

        this.loadingService.hide();
      });
    });
  }

  private async initializeActions() {
    const actions = [];

    const action1 = {
      function: () => {
        this.deleteInventory();
      },
      showAction: true,
      title: `Διαγραφή Απογραφής`,
    };

    actions.push(action1);
    this.basicDetailsConfig.actions = actions;
  }

  private deleteInventory() {
    const confirm = this.matDialog.open(SimpleConfirmActionDialogComponent, {
      data: {
        title: 'Διαγραφή Απογραφής',
        message: `Είστε σίγουροι ότι
        θέλετε να διαγράψετε την απογραφή ${this.inventory.id};`
      }
    });

    confirm.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          await this.commonService.deleteItemWithParam(`inventory/web/${this.inventory.id}`);
          this.toastMessagesService.toastMessages(`Η διαγραφή της απογραφής πραγματοποιήθηκε με επιτυχία`);
          this.router.navigate(['/inventories']);
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }


  public setCardWidth(): number {
    return this.showEventLogs() ? 66 : 100;
  }

  protected showActions(): boolean {
    return this.authService.isUserBelongsTo('basicUser');
  }

  public showEventLogs(): boolean {
    return this.authService.isUserBelongsTo('basicUser') ||
      this.authService.isUserBelongsTo('transportManager') ||
      this.authService.isUserBelongsTo('customerManager');
  }
}
